var map = {
	"./01.png": 64392,
	"./02.png": 1251,
	"./03.png": 53498,
	"./04.png": 77269,
	"./5-stars.svg": 8294,
	"./AppStore.svg": 97449,
	"./Applicants-illustration.png": 34629,
	"./Appstore-logo.png": 38937,
	"./Availability-illustration.png": 18493,
	"./Category-illustration.png": 17662,
	"./Choice Filling-illustration.png": 46474,
	"./Cta-banner-image.png": 98520,
	"./Fee-illustration.png": 43294,
	"./Google-logo.png": 78590,
	"./InfluencerRoadMap1.png": 6125,
	"./InfluencerRoadMap2.png": 24502,
	"./InfluencerRoadMap3.png": 20831,
	"./Playstore-logo.png": 25602,
	"./Registration-mcc-illustration.png": 32567,
	"./Report-illustration.png": 43664,
	"./StarRating.png": 71582,
	"./Verification-illustration.png": 21501,
	"./afmc-illustration.png": 45449,
	"./aiims-illustration.png": 93151,
	"./ambassador-cta-banner-mob.png": 34977,
	"./ambassador-cta-banner-web.png": 46713,
	"./ambassador-hero-desktop.png": 67642,
	"./ambassador-hero-mobile.png": 58278,
	"./ambassadorsDoctorDesktop.png": 14632,
	"./ambassadorsDoctorMobile.png": 97364,
	"./brain-illustration.png": 87866,
	"./campus-illustration.png": 43119,
	"./careers-primary.png": 37073,
	"./cash-illustration.png": 8077,
	"./center-iphone.png": 46026,
	"./choice-filing-illustration.png": 38013,
	"./clarity-illustration.png": 5670,
	"./cmc-illustration.png": 38567,
	"./community-illustration.png": 48651,
	"./conducted-illustration.png": 50763,
	"./counselling-chaos-1.png": 441,
	"./counselling-chaos-2.png": 33858,
	"./counselling-chaos-3.png": 8011,
	"./counselling-chaos-4.png": 58100,
	"./counselling-chaos-5.png": 79229,
	"./counselling-chaos-6.png": 98022,
	"./discount-tag.png": 13119,
	"./dnb-pdcet-exam-hero.png": 16715,
	"./doctor-men.png": 4055,
	"./doctors.png": 24673,
	"./exam-illustration.png": 95525,
	"./exam-page-features.png": 99480,
	"./exams-overview-brief.png": 86154,
	"./exams-overview-counselling.png": 94171,
	"./exams-overview-eligibility.png": 94013,
	"./exploring-illustration.png": 5570,
	"./faster-chart.svg": 28641,
	"./flow-mobile-zy.png": 15630,
	"./flow-web-zy.png": 34232,
	"./google-play-badge.png": 19163,
	"./growth-graph.svg": 4479,
	"./growth-illustration.png": 96649,
	"./heart-illustration.png": 83922,
	"./hello-zynerd-choice-list.png": 56055,
	"./hello-zynerd-cut-offs.png": 69378,
	"./hello-zynerd-fees.png": 5602,
	"./hello-zynerd-insights-bg.png": 99880,
	"./hello-zynerd-insights-logo.png": 67384,
	"./hello-zynerd-strategies.png": 73346,
	"./hello-zynerd-tools.png": 78588,
	"./hello-zynerd-updates.png": 71579,
	"./idea-illustration.png": 67733,
	"./influencer-hero-desktop.png": 39032,
	"./influencer-hero-mobile.png": 91076,
	"./information-table-illustration.png": 53877,
	"./infrastructure-illustration.png": 74453,
	"./inicet-exam-hero.png": 24390,
	"./landingHeroMobile.png": 80078,
	"./landingHeroWeb.png": 21928,
	"./left-1st-iphone.png": 32095,
	"./left-2nd-iphone.png": 55467,
	"./low-cost-chart.svg": 97678,
	"./mamc-illustration.png": 81232,
	"./map-illustration.png": 77100,
	"./mcc-neet-flow-mob.png": 77789,
	"./mcc-web-zy.png": 45965,
	"./mds-exam-hero.png": 39082,
	"./microscope-illustration.png": 17302,
	"./modes-illustration.png": 41914,
	"./money-illustration.png": 76958,
	"./number-illustration.png": 76915,
	"./offered-illustration.png": 23181,
	"./participation-illustration.png": 7139,
	"./pg-exam-hero.png": 1471,
	"./placement-illustration.png": 62909,
	"./promo-hero.webp": 1833,
	"./rankings-illustration.png": 41661,
	"./recognition-illustration.png": 52169,
	"./registration-illustration.png": 78839,
	"./reportpad-illustration.png": 78085,
	"./resources-illustration.png": 74439,
	"./right-1st-iphone.png": 43188,
	"./right-2nd-iphone.png": 78372,
	"./routeMap1.png": 45733,
	"./routeMap2.png": 43310,
	"./routeMap3.png": 16951,
	"./routeMap4.png": 37336,
	"./routeMap5.png": 26401,
	"./routeMap6.png": 77418,
	"./seat-illustration.png": 62203,
	"./ss-exam-hero.png": 4114,
	"./stethoscope-illustration.png": 36475,
	"./support-call.png": 63307,
	"./support-mail.png": 61894,
	"./support-user.png": 88818,
	"./tailor-illustration.png": 51417,
	"./tailored-illustration.png": 76488,
	"./teeth-illustration.png": 77084,
	"./testimonial1.jpg": 18039,
	"./testimonial1.png": 88455,
	"./testimonial2.jpg": 83816,
	"./testimonial2.png": 85804,
	"./testimonial3.png": 21717,
	"./testimonial4.png": 97946,
	"./testimonial5.png": 45699,
	"./testimonial6.png": 8840,
	"./testimonial7.png": 19057,
	"./testimonial8.png": 41750,
	"./testimonial9.png": 38687,
	"./trends-illustration.png": 82422,
	"./ug-exam-hero.png": 20704,
	"./ug-video-thumbnail.webp": 71476,
	"./videos-illustration.png": 48394,
	"./whyZynerdAmbas-1.png": 63763,
	"./whyZynerdAmbas-2.png": 89272,
	"./whyZynerdAmbas-3.png": 61985,
	"./whyZynerdAmbas-4.png": 78894,
	"./whyZynerdAmbas-5.png": 68887,
	"./whyZynerdInfluencer1.png": 34711,
	"./whyZynerdInfluencer2.png": 50428,
	"./whyZynerdInfluencer3.png": 63493,
	"./whyZynerdInfluencer4.png": 78826,
	"./zynerd-allotment-mapping.png": 77929,
	"./zynerd-closing-ranks.png": 89223,
	"./zynerd-dashboard.png": 7660,
	"./zynerd-institutes.png": 76338,
	"./zynerd-seat-matrix.png": 63855,
	"./zynerd-videos.png": 87854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62229;